module.exports = __webpack_public_path__ + "static/convertcalculator-2-487f2d294dd8b87bf53ab805794ac381.png";